import React, { useState } from "react";
import { X } from "lucide-react";
import { AppDownloadButtons } from "@/components/AppDownloadButtons";
import { APPS_PUBLISHED } from "@/lib/appStore";

const KEY = "ssm_app_banner_dismissed";

// Dismissible banner nudging users to download the mobile app. Persists dismissal in localStorage.
export function AppDownloadBanner() {
  const [dismissed, setDismissed] = useState(() => {
    try { return localStorage.getItem(KEY) === "1"; } catch { return false; }
  });
  if (!APPS_PUBLISHED) return null;
  if (dismissed) return null;

  const dismiss = () => {
    try { localStorage.setItem(KEY, "1"); } catch { /* ignore */ }
    setDismissed(true);
  };

  return (
    <div
      className="mb-8 rounded-2xl border border-[#2D6A4F]/25 bg-[#2D6A4F]/5 p-5 flex items-center justify-between gap-4 flex-wrap"
      data-testid="app-download-banner"
    >
      <div className="flex items-center gap-3">
        <div className="w-11 h-11 rounded-xl flex items-center justify-center shrink-0 overflow-hidden">
          <img src={`${process.env.PUBLIC_URL}/app-icon.png`} alt="Screening Services Mobile app icon" className="w-full h-full object-contain" />
        </div>
        <div>
          <h2 className="font-heading text-lg text-[#1E3F33]">Get the mobile app</h2>
          <p className="text-sm text-[#5C6B64]">Manage everything on the go — available on Android and iOS.</p>
        </div>
      </div>
      <div className="flex items-center gap-2">
        <AppDownloadButtons />
        <button
          type="button"
          data-testid="app-download-banner-dismiss"
          onClick={dismiss}
          aria-label="Dismiss"
          className="text-[#8A9A86] hover:text-[#1E3F33] p-1.5 rounded-lg"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
